import React from "react";
import TripInformationSection from "../common/TripInformationSection";


const FaroeTripInformationSection = () => {
    return (
        <TripInformationSection
            content={{
                title: 'faroe_description_title',
                descriptions: 'faroe_descriptions'
            }}
        />
    );
}


export default FaroeTripInformationSection;
